import { FunctionOutput } from "../function.types"
import { TripID } from "../trips/trip.interface"
import { IProfile } from "./profile.interface"

export enum ProfileRequestType {
  AllTripUsersProfiles = "allTripUsersProfiles",
  OwnProfiles = "ownProfiles",
}

export type GetProfilesInput =
  | {
      type: ProfileRequestType.AllTripUsersProfiles
      tripId: TripID
    }
  | {
      type: ProfileRequestType.OwnProfiles
    }

export interface GetProfilesResult {
  profiles: IProfile[]
}

export type GetProfilesOutput = FunctionOutput<GetProfilesResult>
